<div class="mobile-navigation show-mobile">
  <div class="mobile-header">
    <button class="menu-toggle" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen">
      <span class="hamburger">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>
    
    <h2 class="page-title">{{ translatedTitle || (pageTitle | translate) || (_translateService.Keys.HOME_WELCOME | translate) }}</h2>
    
    <button *ngIf="showBackButton" class="back-button" (click)="goBack()">
      <img src="../../../assets/arrow-left.svg" alt="{{ _translateService.Keys.COMMON_BACK | translate }}">
    </button>
    <div *ngIf="!showBackButton" class="spacer"></div>
  </div>

  <!-- Policy Dropdown for Mobile -->
  <div class="policy-dropdown-container" *ngIf="showPolicyDropdown && quotes.length > 1">
    <button class="policy-dropdown-toggle" (click)="togglePolicyDropdown()" [class.open]="policyDropdownOpen">
      <span class="policy-name">{{ getQuoteName(quotes[activeQuoteIndex]) }}</span>
      <span class="dropdown-arrow"></span>
    </button>
    <div class="policy-dropdown-menu" [class.open]="policyDropdownOpen">
      <div *ngFor="let quote of quotes; let i = index" 
           class="policy-option" 
           [class.active]="activeQuote(i)"
           (click)="selectQuote(i)">
        {{ getQuoteName(quote) }}
      </div>
    </div>
  </div>

  <div class="mobile-menu-overlay" [class.open]="menuOpen" (click)="closeMenu()"></div>
  
  <div class="mobile-menu" [class.open]="menuOpen">
    <div class="menu-header">
      <div class="portalLogo"></div>
      <div class="header-actions">
        <app-language-switcher></app-language-switcher>
        <button class="close-menu" (click)="closeMenu()">
          <img src="../../../assets/close.svg" alt="{{ _translateService.Keys.COMMON_CANCEL | translate }}">
        </button>
      </div>
    </div>
    
    <nav class="menu-content">
      <!-- Home Link -->
      <ul class="menu-links">
        <li>
          <a routerLink="/coverage" (click)="closeMenu()">
            {{ _translateService.Keys.HOME_WELCOME | translate }}
          </a>
        </li>
      </ul>
      
      <h3>{{ _translateService.Keys.POLICIES_REQUESTS | translate }}</h3>
      <ul class="requests-list">
        <li>
            <a [href]="'mailto:' + email + '?subject=' + getGeneralLiabilityEmailSubject()">
              {{ _translateService.Keys.POLICIES_GENERAL_LIABILITY_QUOTE | translate }}
            </a>
        </li>
        <li>
          <a [href]="claimsReportingUrl" target="_blank">
            {{ _translateService.Keys.POLICIES_CLAIMS_REPORTING | translate }}
          </a>
        </li>
      </ul>
      
      <!-- Contact Us Section -->
      <div class="contact-section">
        <h3>{{ _translateService.Keys.COMMON_CONTACT_US | translate }}:</h3>
        <div class="contact-info">
          <a [href]="'mailto:' + email + '?subject=' + getGeneralLiabilityEmailSubject()">
            {{email}}
          </a>
          <span class="divider">|</span>
          <a [href]="'tel:' + phone">{{ phone }}</a>
        </div>
      </div>
      
      <div class="menu-actions">
        <button class="logout-button" (click)="logout()">
          <img src="../../../assets/logout.svg" alt="logout">
          {{ _translateService.Keys.COMMON_LOGOUT | translate }}
        </button>
      </div>
    </nav>
  </div>
</div>